// extracted by mini-css-extract-plugin
export default {"styles":"eligible_styles__VDiRY"};